import React, { useEffect } from "react";
import { useState } from "react";
import Countable from "./Countable";
import Requestable from "./Requestable";
import { baseURL } from "../../constants/Api";
import axios from "axios";
import { convert_24_to_12, CurrencySymbol } from "../../utils/util";
import Skeleton from "../../components/skeletons/skeleton";
import Emty from "../../components/emty-state/Emty";
function Tabdesign(props) {
  const [tabActive, SetTabActive] = useState(1);
  const [countableList, SetCountableList] = useState([]);
  const [houseKeepingData, sethouseKeepingData] = useState([]);
  const [requestableList, SetRequestableList] = useState([]);
  const hotelId = localStorage.getItem("hotel-id");
  const [loading, setLoading] = useState(false);

  const getService = () => {
    setLoading(true);
    let config = {
      method: "get",
      url: `${baseURL}/api/servicesV2/${hotelId}`,
    };
    axios
      .request(config)
      .then((response) => {
        setLoading(false);
        if(response.data?.success){
          SetCountableList(response.data.data.Commodities);
          sethouseKeepingData(response.data.data)
          SetRequestableList(response.data.data.Services);
        }

      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  useEffect(() => {
    getService();
  }, []);

    // currency setup
 const currencySymbol = CurrencySymbol();


  return (
    <div className="w-full" style={{marginBottom:"100px"}}>
      {houseKeepingData ?.start_time && houseKeepingData?.close_time ? <div className="text-xs text-[#BABABA] mt-6">Working hours - {convert_24_to_12(houseKeepingData?.start_time)} to {convert_24_to_12(houseKeepingData?.close_time)}</div> : "" }
          {houseKeepingData?.is_open == 0 &&<div className="house-keeping-isactive-info mt-5"> House Keeping service is currently unavailable at this moment. </div> }
       {!loading  ? <>
        <div className="w-full flex lg:mt-[20px] mt-7 space-x-4">
          <div
            onClick={() => SetTabActive(1)}
            className={tabActive != 1 ? "tab-manu " : "active-tab-menu "}
          >
            Commodities
          </div>
          <div
            onClick={() => SetTabActive(2)}
            className={tabActive != 2 ? "tab-manu" : "active-tab-menu"}
          >
            Service Request
          </div>
        </div>
        {tabActive == 1 && (countableList?.length ? 
            <Countable
            active={houseKeepingData}
            countable={countableList}
            guestId={props.guestId}
            reservationId={props.reservationId}
            roomId={props.roomId}
            multipleRoom={props.multipleRoom}
            checkedIn={props.checkedIn} currencySymbol={currencySymbol}/>
          :  
            <div className="w-full flex justify-center items-center mt-10">
               <Emty item="Commodities" />
            </div>
        )}
        {tabActive == 2 && ( requestableList?.length ?
            <Requestable
            active={houseKeepingData}
            requestableList={requestableList}
            guestId={props.guestId}
            reservationId={props.reservationId}
            roomId={props.roomId}
            multipleRoom={props.multipleRoom}
            checkedIn={props.checkedIn} currencySymbol={currencySymbol}/>
            : 
          <div className="w-full flex justify-center items-center mt-10">
              <Emty item="Services" />
          </div>
          ) 
        }
        </> 
        :
        <Skeleton type="modal" />}
    </div>
  );
}

export default Tabdesign;
 